import { businessMatchingBusinessEntityPreviewPath } from "../../../routes";
import { createUnifiedFile } from "./UnifiedFile";
import { Step1FormData } from "../../public/business_matching/owned_business_entities/lib/useStep1Form";
import { Step2FormData } from "../../public/business_matching/owned_business_entities/lib/useStep2Form";
import { BusinessEntityAttributesFormData } from "../../admin/shared/lib/useBusinessEntityForm";
import YubinBango from "yubinbango.js";
import { fullwidthTohalfWidth } from "./numberUtils";
import { businessTypes } from "./businessTypes";

export const openPreview = async ({
  businessEntity,
  designedArchitecturalWorksImages,
}: {
  businessEntity:
    | (Step1FormData & Step2FormData)
    | BusinessEntityAttributesFormData;
  designedArchitecturalWorksImages: (
    | File
    | { url: string; signed_id: string }
  )[][];
}) => {
  let address1 = businessEntity.address1;
  if (businessEntity.display_address_restricted && businessEntity.postal_code) {
    try {
      const transformed = fullwidthTohalfWidth(
        businessEntity.postal_code,
      ).replace(/[ー\-−―‐ｰ－]/g, "");
      if (transformed.length === 7) {
        const addressData = await YubinBango.getAddress(transformed);
        address1 = addressData.locality;
      }
    } catch {
      // エラー時は入力値を使う
    }
  }

  const businessType = businessTypes.find((b) => b.value === businessEntity.business_type)?.label;

  const address2 = businessEntity.display_address_restricted
    ? ""
    : businessEntity.address2;
  const address3 = businessEntity.display_address_restricted
    ? ""
    : businessEntity.address3;
  const postal_code = businessEntity.display_address_restricted
    ? null
    : businessEntity.postal_code;

  localStorage.setItem(
    "businessEntityPreviewParams",
    JSON.stringify({
      businessEntity: {
        ...businessEntity,
        business_type: businessType,
        address1,
        address2,
        address3,
        postal_code,
      },
      logoImage: createUnifiedFile(businessEntity.logo_image).url,
      createdAt: new Date().getTime(),
      designedArchitecturalWorksImages: designedArchitecturalWorksImages.map(
        (files) =>
          files.map((file) => {
            if (file instanceof File) {
              return {
                url: URL.createObjectURL(file),
                signed_id: "",
              };
            } else {
              return file;
            }
          }),
      ),
    }),
  );
  window.open(businessMatchingBusinessEntityPreviewPath(), "_blank");
};
